import { createLazyFileRoute } from "@tanstack/react-router";

import { PrintersPage } from "@/features/admin/routes/Printers";

export const Route = createLazyFileRoute("/_auth/admin/printers/")({
  component: PrintersPage,
});
